var App = App || {};
App._i18n = App._i18n || {};

App._i18n['fr_FR'] = {
    'close':
        'fermer',

    'Do you confirm this action?':
        'Confirmez-vous cette action ?',

    'An error has occured. Please try later.':
        'Une erreur est survenue. Veuillez ré-essayer plus tard.',

    'An error has occured while saving the course. Please try later.':
        'Une erreur est survenue pendant la sauvegarde du cours. Veuillez ré-essayer plus tard.',

    'Subscribe for free to this course to see those videos.':
        'Inscrivez-vous gratuitement à ce cours pour visionner ces vidéos.',

    'You must connect to see this video.':
        'Connectez-vous pour consulter cette vidéo.',

    'To see this video you must to subscribe at this course. Do you want do now ? it s free !':
        'Pour voir cette vidéo, vous devez vous inscrire au cours. Voulez-vous le faire maintenant ? C\'est gratuit !',

    'Connect':
        'Connectez-vous',

    'Yes':
        'Oui',

    'No':
        'Non',
};
